import 'core-js/actual'
import './registerServiceWorker'
import { BrowserTracing } from '@sentry/tracing'
import * as Sentry from '@sentry/vue'
import mitt from 'mitt'
import { createApp, h } from 'vue'
import linkify from 'vue-linkify'
import VueTippy from 'vue-tippy'

import App from './App'
import router from './router'
import store from './store'

const app = createApp({
  router,
  store,
  render: () => h(App)
})

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    app,
    dsn: 'https://be196de2c3c440dcac39c083435aab88@o1224056.ingest.sentry.io/6368769',
    integrations: [
      new BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
        tracingOrigins: ['localhost', 'api.bottle.com', /^\//]
      })
    ],
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
    logErrors: true
  })

  Sentry.setUser({ domain: window.location.hostname })

  // Google Tag Manager
  ;(function (w, d, s, l, i) {
    w[l] = w[l] || []
    w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' })
    var f = d.getElementsByTagName(s)[0],
      j = d.createElement(s),
      dl = l != 'dataLayer' ? '&l=' + l : ''
    j.async = true
    j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl
    f.parentNode.insertBefore(j, f)
  })(window, document, 'script', 'dataLayer', 'GTM-5KMZQ29Q')

  // Google Tag Manager (noscript)
  const noscript = document.createElement('noscript')
  const iframe = document.createElement('iframe')
  iframe.src = 'https://www.googletagmanager.com/ns.html?id=GTM-5KMZQ29Q'
  iframe.height = '0'
  iframe.width = '0'
  iframe.style.display = 'none'
  iframe.style.visibility = 'hidden'
  noscript.appendChild(iframe)
  document.body.insertBefore(noscript, document.body.firstChild)
}

const bus = mitt()
app.provide('bus', bus)

app.config.globalProperties.window = window
app.config.globalProperties.$store = store
app.provide('$store', store)

app.use(router)
app.use(store)

app.use(VueTippy, {
  defaultProps: {
    placement: 'bottom',
    arrow: true,
    theme: 'dark',
    allowHTML: true,
    delay: [300, null]
  }
})

app.directive('linkified', linkify)
app.mount('#app')

// Toasts
// https://github.com/Maronato/vue-toastification
import 'vue-toastification/dist/index.css'

import Toast, { PluginOptions } from 'vue-toastification'

const options = {
  position: 'bottom-right',
  hideProgressBar: true,
  icon: false,
  closeButton: false,
  toastClassName: 'tw',
  timeout: 4000
}

app.use(Toast, options)
